module.exports = __webpack_public_path__ + "img/slide2.b68750e0.jpg";